import { useSwrNoAuth } from "../../swr/useSwrNoAuth";


export const useFetchBranchScore = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `games/roulette/restaurants/${restaurantId}/setting/branch-score/` : null;
  const { data: branchScore, error, isLoading } = useSwrNoAuth<number>(fetcherKey)
  return { branchScore, isLoading, error };
};